export default {
  common: {
    确定: '确定',
    取消: '取消',
    完成: '完成',
    重置: '重置',
    请选择: '请选择',
    暂无数据: '暂无数据'
  },
  'input-amount': {
    千: '千',
    万: '万',
    十万: '十万',
    百万: '百万',
    千万: '千万',
    亿: '亿',
    十亿: '十亿',
    百亿: '百亿',
    千亿: '千亿',
    转出全部: '转出全部'
  },
  scrollList: {
    加载中: '加载中...'
  },
  pullRefresh: {
    下拉刷新: '下拉刷新',
    释放立即刷新: '释放立即刷新',
    刷新中: '刷新中…'
  },
  'datetime-picker': {
    重置: '重置',
    年: '年',
    月: '月',
    日: '日',
    时: '时',
    分: '分',
    秒: '秒',
    此刻: '此刻',
    一: '一',
    二: '二',
    三: '三',
    四: '四',
    五: '五',
    六: '六',
    周日: '日',
    请选择年份: '请选择年份',
    请选择月份: '请选择月份',
    返回: '返回',
    '1月': '1月',
    '2月': '2月',
    '3月': '3月',
    '4月': '4月',
    '5月': '5月',
    '6月': '6月',
    '7月': '7月',
    '8月': '8月',
    '9月': '9月',
    '10月': '10月',
    '11月': '11月',
    '12月': '12月'
  },
  loading: {
    '加载中...': '加载中...'
  },
  uploader: {
    点击预览: '点击预览',
    请重试: '请重试',
    文件过大: '文件过大\n请重试',
    重新上传: '重新上传',
    上传失败: '上传失败'
  },
  groupSelect: {
    请输入: '请输入',
    无结果: '无结果'
  },
  poplist: {
    无数据: '无数据'
  },
  popupFilter: {
    筛选: '筛选'
  },
  pagination: {
    跳转至: '跳转至',
    每页显示: '每页显示',
    条: '条',
    页: '页'
  }
};